import actionCreatorFactory from "typescript-fsa";
import { IMessagesNtc } from "../../types";

const actionCreator = actionCreatorFactory("MESSAGES_NTS");

export const addMessageNtc = actionCreator<IMessagesNtc>("ADD_MESSAGE_NTC");
export const updateMessageNtc =
  actionCreator<IMessagesNtc[]>("UPDATE_MESSAGE_NTC");
